import { Extension } from '@tiptap/core';
import { Plugin } from '@tiptap/pm/state';
import { Decoration, DecorationSet } from '@tiptap/pm/view';

export const decorateSelection = Extension.create({
  name: 'decorateSelection',
  addProseMirrorPlugins() {
    return [
      new Plugin({
        props: {
          decorations(state) {
            const selection = state.selection;
            if (selection.empty) return;
            return DecorationSet.create(state.doc, [
              Decoration.inline(selection.from, selection.to, { class: 'selected-text' }),
            ]);
          },
        },
      }),
    ];
  },
});
